/* eslint-disable no-console */
import { isEmpty, cloneDeep } from 'lodash';
import throttle from 'lodash/throttle';
import { PRAPARE_INFO } from './Utils';
import { convertToLowerCase } from '../../Components/Common/Util';

// Desc: This file contains the helper functions for the Assessment page.

// Function to set checkbox values
export const getAnsIdsForCheckBox = (field, updatedValue) => {
    let arr = Array.isArray(field?.value?.checkboxAns) ? field?.value?.checkboxAns : [];
    if (updatedValue.checked) {
        arr.push(parseInt(updatedValue.value));
    } else {
        arr = arr.filter((a) => !(a === parseInt(updatedValue.value)));
    }
    return arr?.length > 0 ? arr : '';
};

const getAnswerId = (ansArray, val) => {
    if (!Array.isArray(ansArray) || ansArray.length === 0) {
        return '';
    }

    let ansInternalId = '';

    for (let i = 0; i < ansArray.length; i++) {
        if (ansArray[i].answerInternalIdentifier === val) {
            ansInternalId = ansArray[i].answerId;
            break;
        }
    }
    return ansInternalId;
};

// function to set text input values
export const getAnswersForTextInputs = (field, updatedValue, ansItem) => {
    let arr = Array.isArray(field.value?.textAns) ? field.value?.textAns : [];
    let hasVal = arr?.findIndex((a) => a.answerInternalId === ansItem.answerInternalIdentifier);
    if (hasVal !== -1) {
        arr[hasVal] = {
            answerInternalId: ansItem.answerInternalIdentifier,
            answer: updatedValue?.label ? updatedValue?.label : updatedValue.toString()
        };
    } else {
        arr.push({
            answerInternalId: ansItem.answerInternalIdentifier,
            answer: updatedValue?.label ? updatedValue?.label : updatedValue.toString()
        });
    }
    return arr?.length > 0 ? arr : '';
};

export const getAnswerForDropdown = (field, updatedValue, ansItem) => {
    let res;
    if (field.answerControlType === 103 || field?.answerControlType === 120) {
        return (res = updatedValue);
    } else {
        res = field?.value.dropdownAns?.length
            ? field?.value.dropdownAns.filter((item) => item.answerInternalIdentifier !== ansItem?.answerInternalIdentifier)
            : [];

        res.push({ answerInternalIdentifier: ansItem?.answerInternalIdentifier, ...updatedValue });
        return res;
    }
};

export const getPrapareResponse = (tempQuestionsData, isSubmitted, rowsData) => {
    let tempQuesResp = [];

    tempQuestionsData?.questions.forEach((a) => {
        let textQuesResponses = [];
        let ansIdStr = '';
        let answerIdInAllLanguage = '';

        let radioStr = '';
        let checkboxStr = '';
        let dropdownStr = '';
        let dateStr = '';
        let ratingStr = '';
        let textStr = '';

        if (a.value?.radioAns) {
            radioStr = a.value?.radioAns?.toString() || '';
            answerIdInAllLanguage += getAnswerId(a.answers, a.value.radioAns) + ', ';
        }
        if (a.value?.checkboxAns) {
            checkboxStr = a.value?.checkboxAns?.toString() || '';
            a.value.checkboxAns.forEach((val) => {
                answerIdInAllLanguage += getAnswerId(a.answers, val) + ', ';
            });
        }
        if (a.value?.dropdownAns) {
            dropdownStr = a.value?.dropdownAns?.value?.toString() || '';
            let andIDStr = getAnswerId(a.answers, a.value.dropdownAns?.value);
            if (andIDStr) {
                answerIdInAllLanguage += getAnswerId(a.answers, a.value.dropdownAns?.value) + ', ';
            } else {
                let drpDwnArr = a.answers.filter((ans) => {
                    return (
                        (ans.answerControlType === 103 || ans.answerControlType === 120) &&
                        ans?.options?.length > 0 &&
                        ans?.options?.find((op) => op.answerInternalIdentifier === a.value.dropdownAns?.value)
                    );
                });
                answerIdInAllLanguage += getAnswerId(drpDwnArr[0]?.options, a.value.dropdownAns?.value) + ', ';
            }
        }
        if (a.value?.dateAns) {
            dateStr = a.value?.dateAns?.toString() || '';
            answerIdInAllLanguage += getAnswerId(a.answers, a.value.dateAns) + ', ';
        }
        if (a.value?.textAns) {
            textQuesResponses = a.value?.textAns?.length
                ? a.value?.textAns?.map((e) => {
                      return {
                          answerInternalId: e?.answerInternalId ? e?.answerInternalId : e?.value,
                          ansId: e?.answerInternalId ? e?.answerInternalId : e?.value,
                          answer: e?.answer ? e?.answer : e?.label ? e?.label : ''
                      };
                  })
                : [];
            textQuesResponses.forEach((txt) => {
                textStr += txt.answerInternalId + ', ';
                answerIdInAllLanguage += getAnswerId(a.answers, txt.answerInternalId) + ', ';
            });
        }
        if (a.value?.ratingAns) {
            ratingStr = a.value?.ratingAns?.toString() || '';
            answerIdInAllLanguage += getAnswerId(a.answers, a.value.ratingStr) + ', ';
        }

        ansIdStr = [radioStr, checkboxStr, dropdownStr, dateStr, textStr, ratingStr].filter(Boolean).join(', ');

        if (ansIdStr !== '' || textQuesResponses?.length > 0) {
            tempQuesResp.push({
                quesId: a.questionId,
                questionInternalId: parseInt(a.questionInternalIdentifier),
                ansId: answerIdInAllLanguage.replace(/, $/, ''), // Remove trailing comma and space
                autoGeneratedNeed: true,
                answerInternalId: ansIdStr.replace(/, $/, ''), // Remove trailing comma and space if it exists
                textQuesResponses: textQuesResponses,
                dropdownAns: a.value?.dropdownAns?.length ? a.value?.dropdownAns : []
            });
        } else {
            tempQuesResp.push({
                quesId: a.questionId,
                questionInternalId: parseInt(a.questionInternalIdentifier),
                ansId: null, // Remove trailing comma and space
                answerInternalId: null, // Remove trailing comma and space if it exists
                textQuesResponses: null,
                dropdownAns: a.value?.dropdownAns?.length ? a.value?.dropdownAns : []
            });
        }
        if (a.value?.tableAns) {
            a.value?.tableAns?.length > 0 &&
                a.value?.tableAns.forEach((tableA, inx) => {
                    if (tableA.value !== '' && !(typeof tableA.value !== 'number' && isEmpty(tableA.value))) {
                        let tableTextQuesResponses = [];

                        if (tableA?.textAns?.length > 0) {
                            tableTextQuesResponses = tableA?.textAns?.filter((txtA) => txtA.answer !== '') || [];
                            tableTextQuesResponses.forEach((txt) => {
                                textStr += txt.answerInternalId + ', ';
                                answerIdInAllLanguage += getAnswerId(a.answers, txt.answerInternalId) + ', ';
                            });
                        }
                        tempQuesResp.push({
                            quesId: parseInt(tableA.questionId),
                            questionInternalId: parseInt(tableA.questionInternalIdentifier),
                            ansId: tableA.answerControlType === 103 ? tableA.value?.value?.toString() : tableA.value?.toString(),
                            autoGeneratedNeed: true,
                            answerInternalId: tableA.answerInternalIdentifier?.toString(), // Remove trailing comma and space
                            textQuesResponses: [...textQuesResponses, ...tableTextQuesResponses]
                        });
                    }
                });
        }
    });
    return tempQuesResp;
};

export const checkAllenabledCheckboxHasValuesInPrapare = (
    questionsData,
    questionRules,
    assessmentData,
    mandatoryQuestions,
    checkQn,
    immediateRes
) => {
    // const copyQuestionsData = [...questionsData?.questions] || questionsData;
    const copyQuestionsData = Array.isArray(questionsData?.questions) ? [...questionsData.questions] : questionsData || [];

    let disableQuestions = [];
    let mandatoryQuestionsToCheck = [];
    copyQuestionsData.forEach((qn) => {
        const matchedQuestion = mandatoryQuestions.find((item) => item.questionInternalIdentifier === qn.questionInternalIdentifier);
        if (matchedQuestion) {
            mandatoryQuestionsToCheck.push(qn);
        }
    });
    let questionsToLoop;
    if (mandatoryQuestionsToCheck?.length) {
        questionsToLoop = mandatoryQuestionsToCheck;
    } else {
        questionsToLoop = copyQuestionsData;
    }
    if (questionsToLoop?.length) {
        questionsToLoop.forEach((ques, index) => {
            if (copyQuestionsData[index]?.isMandate === true || mandatoryQuestionsToCheck?.length || checkQn) {
                const value = ques?.value;
                if (value === undefined || value === null) {
                    // If value is undefined or null, add to disableQuestions
                    disableQuestions.push(ques);
                } else if (typeof value === 'object' && !Array.isArray(value)) {
                    // If value is an object but not an array
                    const hasCheckboxVals = Array.isArray(value.checkboxVals) && value.checkboxVals.length > 0;
                    const hasTextVals = Array.isArray(value.textVals) && value.textVals.length > 0;
                    const hasTextAns = Array.isArray(value.textAns) && value.textAns.length > 0;
                    let textAns = [];
                    if (hasTextAns) {
                        value?.textAns?.forEach((item) => {
                            if (item?.answer !== '') {
                                textAns.push(item);
                            }
                        });
                    }
                    const hasRadioVals = value.radioVals !== undefined && value.radioVals !== null;
                    const hasRadioInRadio =
                        value?.radioAns !== '' && value?.radioAns !== undefined && value?.radioAns !== null && !isNaN(value.radioAns);
                    const hasSelectionVals = value.label !== undefined && value.value !== undefined;
                    const hasDropdownAns = value.dropdownAns !== undefined && value.dropdownAns !== null;
                    const hasCheckboxAns = Array.isArray(value.checkboxAns) && value.checkboxAns.length > 0;
                    const hasRadioAns =
                        value.radioAns !== '' && value.radioAns !== undefined && value.radioAns !== null && !isNaN(value.radioAns);
                    const hasDateAns =
                        Array.isArray(value.dateAns) &&
                        value.dateAns.length > 0 &&
                        value.dateAns.every((date) => date instanceof Date && !isNaN(date.getTime()));

                    if (
                        !hasCheckboxVals &&
                        !hasTextVals &&
                        textAns?.length === 0 &&
                        !hasRadioVals &&
                        !hasRadioInRadio &&
                        !hasSelectionVals &&
                        !hasDropdownAns &&
                        !hasCheckboxAns &&
                        !hasRadioAns &&
                        !hasDateAns
                    ) {
                        disableQuestions.push(ques);
                    }
                } else if (Array.isArray(value)) {
                    // If value is an array, check if it is not empty
                    if (value.length === 0) {
                        disableQuestions.push(ques);
                    }
                } else if (typeof value === 'string' && value.trim() === '') {
                    // If value is a string, check if it is not an empty string
                    disableQuestions.push(ques);
                } else if (typeof value === 'number' && isNaN(value)) {
                    // If value is a number, check if it is not NaN
                    disableQuestions.push(ques);
                }
            }
        });
    }
    if (disableQuestions?.length > 0) {
        disableQuestions = disableQuestions.filter((que) => {
            const isVisible = checkVisibilityRule(que, questionRules, assessmentData, immediateRes);
            return isVisible; // Keep only questions that are visible
        });
    }

    return disableQuestions;
};

export const addQuestionIds = (qndData, questionRulesObj, assessmentData) => {
    let count = 0;

    qndData?.forEach((indexedQns) => {
        if (indexedQns?.innerQuestionaireTemplate) {
            indexedQns.innerQuestionaireTemplate.forEach((item) => {
                if (
                    item.questionText &&
                    checkVisibilityRule(item, questionRulesObj, assessmentData) &&
                    !(item?.questionText?.includes('demographic information') || item?.questionText?.includes('demográficos'))
                ) {
                    count++;
                    item.qnId = count;
                }
            });
        }
    });
    return qndData;
};

export const languageMapping = {
    en: 'English',
    es: 'Español',
    pt: 'Português',
    ru: 'Russian',
    'zh-tw': '中文 (简体)',
    ko: 'Korean',
    'zh-cn': '中文 (简体)',
    // Middle Eastern languages
    ar: 'العربية',
    vi: 'Vietnamese',
    zh: '中文 (简体)'
};

// send respective value to formelements to bind answers
export const constructValue = (item, ansItem, answerLevelRulesObj) => {
    let type = ansItem?.answerControlType || item?.answerControlType;
    switch (type) {
        case 106:
        case 114:
            return item.value?.radioAns;
        case 108:
        case 118:
        case 105:
        case 119:
        case 117:
        case 111:
        case 115:
        case 122:
        case 123:
        case 127:
        case 116:
        case 112:
        case 109:
        case 121:
        case 124:
        case 126:
        case 128:
            let textAnsArr = item.value?.textAns;
            let hasValue = textAnsArr?.length > 0 && textAnsArr.find((ans) => ans.answerInternalId === ansItem?.answerInternalIdentifier);
            let finalValue = hasValue?.answer ? (type === 109 || type === 121 ? new Date(hasValue?.answer) : hasValue?.answer) : '';
            return finalValue;
        case 104:
            return item.value?.checkboxAns || [];
        case 103:
        case 120:
            let values = item.value?.dropdownAns;
            if (values?.length) {
                let isAvailble = values.find((i) => i.answerInternalIdentifier === ansItem?.answerInternalIdentifier);

                return isAvailble ? isAvailble : '';
            } else {
                return item.value?.dropdownAns;
            }
        case 'table':
            return item.value?.tableAns;
        default:
            return '';
    }
};

// bind answers for single answercontrol type
export const handleSingleValue = (b, findQues, ques) => {
    let valueObj = {};
    switch (b.answerControlType) {
        case 106:
        case 114:
            valueObj['radioAns'] = parseInt(findQues?.answerInternalId) || '';
            break;
        case 108:
        case 118:
        case 105:
        case 119:
        case 117:
        case 111:
        case 115:
        case 122:
        case 116:
        case 123:
        case 127:
        case 112:
        case 109:
        case 121:
        case 124:
        case 128:
            valueObj['textAns'] = findQues?.textQuesResponses || '';
            break;
        case 104:
            valueObj['checkboxAns'] = findQues?.answerInternalId?.split(',').map(Number) || '';
            break;
        case 120:
        case 103:
            let ansObj = ques.answers?.find((an) => an?.answerInternalIdentifier === parseInt(findQues?.answerInternalId));
            valueObj['dropdownAns'] = ansObj?.answerText ? { label: ansObj?.answerText, value: ansObj?.answerInternalIdentifier } : '';
            break;
        /*
         * case 109:
         *     valueObj['dateAns'] = findQues?.answerInternalId ? [new Date(findQues?.answerInternalId)] : '';
         *     break;
         */

        default:
            break;
    }
    return valueObj;
};

// bind answers for multiple answercontrol type
export const handleMultipleValue = (findQues, ques) => {
    let valueObj = {};
    let ansType =
        ques?.answerControlType === 103 || ques?.answerControlType === 120
            ? [ques.answerControlType]
            : ques?.answers?.map((ans) => ans.answerControlType || ques.answerControlType);
    // let ansType = ques?.answerControlType === 103 ? [ques.answerControlType] : ques?.answers?.map((ans) => ans.answerControlType);
    let uniqueAnsType = [...new Set(ansType)];
    uniqueAnsType.forEach((atype) => {
        switch (atype) {
            case 106:
            case 114:
                let isradioAns = ques?.answers?.find((ans) =>
                    ans.answerInternalIdentifier === parseInt(findQues?.answerInternalId) && ans.answerControlType
                        ? ans.answerControlType
                        : ques.answerControlType === atype
                );

                /*
                 * let isradioAns = ques?.answers?.find(
                 *     (ans) => ans.answerInternalIdentifier === parseInt(findQues?.answerInternalId) && ans.answerControlType === atype
                 * );
                 */
                valueObj['radioAns'] = isradioAns ? parseInt(findQues?.answerInternalId) : '';
                break;
            case 108:
            case 118:
            case 119:
            case 105:
            case 117:
            case 111:
            case 115:
            case 122:
            case 116:
            case 112:
            case 123:
            case 127:
            case 109:
            case 121:
            case 124:
            case 126:
            case 128:
                valueObj['textAns'] = findQues?.textQuesResponses;
                break;
            case 104:
                let cvalues = findQues?.answerInternalId?.split(',').map(Number);

                let checkboxVals =
                    cvalues?.length &&
                    cvalues.filter((cv) =>
                        ques?.answers?.find((ans) => ans.answerInternalIdentifier === cv && ans.answerControlType === atype)
                    );
                valueObj['checkboxAns'] = checkboxVals;
                break;
            case 120:
            case 103:
            case 125:
                let ansObj = ques.answers?.find((an) => an?.answerInternalIdentifier === parseInt(findQues?.answerInternalId));
                if (!ansObj) {
                    let drpDwnArr = ques.answers.filter((ans) => {
                        return (
                            (ans.answerControlType === 103 || ans.answerControlType === 120 || ans.answerControlType === 125) &&
                            ans?.options?.length > 0 &&
                            ans?.options?.find((op) => op?.answerInternalIdentifier === parseInt(findQues?.answerInternalId))
                        );
                    });
                    let ob = drpDwnArr[0]?.options?.find((op) => op.answerInternalIdentifier === parseInt(findQues?.answerInternalId));
                    valueObj['dropdownAns'] = ob?.answerText ? { label: ob?.answerText, value: ob?.answerInternalIdentifier } : '';
                } else {
                    valueObj['dropdownAns'] = findQues?.dropdownAns?.length ? findQues?.dropdownAns : [];
                }
                break;
            /*
             * case 109:
             *     valueObj['dateAns'] = findQues?.answerInternalId ? [new Date(findQues?.answerInternalId)] : '';
             *     break;
             */

            default:
                break;
        }
    });
    return valueObj;
};

// prepare the rules object
export const prepareQuestionMandate = (entireData) => {
    let memberLevelRule = {};
    let ansRules = [];
    let finalArray = [];
    let fina2Array = [];
    if (entireData?.assessment?.questionaireTemplateValidationRules?.length > 0) {
        entireData?.assessment?.questionaireTemplateValidationRules.forEach((item) => {
            memberLevelRule[item.questionInternalIdentifier] = {
                ...item
            };
            ansRules.push(item);
        });
    }
    if (ansRules) {
        const res = ansRules.map((item) => {
            item?.rule.filter((rules) => {
                if (rules?.action === 'Mandatory' && rules?.answerInternalIdentifier === null) {
                    rules.questionInternalIdentifier = item?.questionInternalIdentifier;
                    finalArray.push(rules);
                }
            });
        });
        finalArray.forEach((item) => {
            item.role.filter((mRole) => {
                if (mRole === entireData?.role) {
                    fina2Array.push(item);
                }
            });
        });
    }
    return fina2Array;
};

export const prepareRulesObj = (entireData) => {
    let questionRules = {};
    let answerLevelRules = {};
    let memberLevelRule = {};
    let memberLevelAlertRules = {};

    // Process question dependency rules
    if (entireData?.assessment?.questionaireTemplateDependencyRule?.questionDependencyRule?.length > 0) {
        entireData?.assessment?.questionaireTemplateDependencyRule?.questionDependencyRule.forEach((item) => {
            questionRules[item.targetQuestionInternalIdentifier] = {
                ...item
            };
        });
    }

    // Process answer dependency rules
    if (entireData?.assessment?.questionaireTemplateDependencyRule?.answerDependencyRule?.length > 0) {
        entireData?.assessment?.questionaireTemplateDependencyRule?.answerDependencyRule.forEach((item) => {
            answerLevelRules[item.targetQuestionInternalIdentifier] = {
                ...item
            };
        });
    }

    // Process member level validation rules
    if (entireData?.assessment?.questionaireTemplateValidationRules?.length > 0) {
        entireData?.assessment?.questionaireTemplateValidationRules.forEach((item) => {
            memberLevelRule[item.questionInternalIdentifier] = {
                ...item
            };
        });
    }

    // Process member level alert rules
    if (entireData?.assessment?.alertRules?.length > 0) {
        entireData?.assessment?.alertRules.forEach((item) => {
            memberLevelAlertRules[item.questionInternalIdentifier] = {
                ...item
            };
        });
    }

    return { questionRules, answerLevelRules, memberLevelRule, memberLevelAlertRules };
};

// to display the question based on the rules
export const checkVisibilityRule = (item, questionRulesObj, assessmentData, immediateAns) => {
    if (!questionRulesObj?.[item?.questionInternalIdentifier]) return true;
    let rules = questionRulesObj?.[item?.questionInternalIdentifier]?.rule;

    let showArr =
        rules?.length > 0 &&
        rules.map((rule) => {
            let showMe = true;
            if (rule?.action === 'Hide') {
                let resp = assessmentData?.responses?.length > 0 ? assessmentData?.responses : [];
                let { sourceQuestionInternalIdentifier, sourceAnswerInternalIdentifier } = rule;
                let sourceQues = resp.find((q) => q.questionInternalId === sourceQuestionInternalIdentifier);
                let sourceAnswer = sourceQues?.answerInternalId?.split(',').map(Number);
                let found = sourceAnswerInternalIdentifier.find((sval) => {
                    return sourceAnswer?.find((val) => val === sval);
                });
                if (found) showMe = false;
            }

            if (rule?.action === 'Show') {
                let resp = assessmentData?.responses?.length > 0 ? assessmentData?.responses : [];
                let { sourceQuestionInternalIdentifier, sourceAnswerInternalIdentifier, sourceAnswerValue } = rule;
                let sourceQues = resp.find((q) => q.questionInternalId === sourceQuestionInternalIdentifier);
                let sourceAnswer = sourceQues?.answerInternalId?.split(',').map(Number);
                let found;

                if (sourceAnswerValue?.length) {
                    found = sourceQues?.textQuesResponses?.find((ansVal) => {
                        return sourceAnswerValue.find((val) => val === ansVal?.answer.toString());
                    });
                } else {
                    found = sourceAnswerInternalIdentifier.find((sval) => {
                        return sourceAnswer?.find((val) => val === sval);
                    });
                }

                if (!found) showMe = false;
            }

            return showMe;
        });

    return showArr.some((val) => val);
};

export const getAllAnswers = (item) => {
    let radioStr = '';
    let checkboxStr = '';
    let dropdownStr = '';

    if (item?.value?.radioAns) {
        radioStr = [parseInt(item?.value?.radioAns)];
    }
    if (item?.value?.checkboxAns) {
        checkboxStr = item?.value?.checkboxAns;
    }
    if (item?.value?.dropdownAns) {
        dropdownStr = [item?.value?.dropdownAns?.value];
    }

    // set into single array of answers
    let ansValues = [...radioStr, ...checkboxStr, ...dropdownStr];
    return ansValues;
};

export const getAllAnswersDupl = (item) => {
    let radioStr = '';
    let checkboxStr = '';
    let dropdownStr = '';
    let textAns = '';

    if (item?.value?.radioAns) {
        radioStr = [parseInt(item?.value?.radioAns)];
    }
    if (item?.value?.checkboxAns) {
        checkboxStr = item?.value?.checkboxAns;
    }
    if (item?.value?.dropdownAns) {
        dropdownStr = item?.value?.dropdownAns?.map((e) => e.value);
    }
    if (item?.value?.textAns) {
        textAns = item?.value?.textAns.map((ans) => ans.answerInternalId);
    }
    // set into single array of answers
    let ansValues = [...radioStr, ...checkboxStr, ...dropdownStr, ...textAns];
    return ansValues;
};

// check all enable rules to disable  answer
export const checkForDisableRules = (item, ansItem, answerLevelRulesObj, value) => {
    if (!answerLevelRulesObj[item.questionInternalIdentifier]) return false;
    let rules = answerLevelRulesObj[item.questionInternalIdentifier].rule;
    let ruleMap = {};
    rules?.length > 0 &&
        rules.forEach((rule) => {
            ruleMap[rule.action] = {
                ...rule
            };
        });

    let disable = false;
    let ansValues = typeof item?.value === 'object' ? getAllAnswers(item) : getAllAnswers({ ...item, value: { radioAns: item.value } });
    // find if target ansitem is called and check enable rules
    if (ruleMap['Enable']) {
        disable = true;
        let { sourceAnswerInternalIdentifier, targetAnswerInternalIdentifier } = ruleMap['Enable'];
        // eslint-disable-next-line no-console
        let targetAnswer = targetAnswerInternalIdentifier?.findIndex((a) => a === ansItem?.answerInternalIdentifier) !== -1;
        if (!targetAnswer) {
            disable = false;
            return disable;
        }
        let found =
            ansValues?.length > 0 &&
            sourceAnswerInternalIdentifier.every((sval) => {
                return ansValues.find((val) => val === sval);
            });
        if (targetAnswer) {
            disable = found === true ? false : true;
        }
        if (targetAnswer && disable) {
            // you can add any additional logic here if needed
        }
        if (targetAnswer && sourceAnswerInternalIdentifier.includes(value?.value)) {
            disable = false;
        }
    }
    // find if target ansitem is called and have Disable rules
    if (ruleMap['Disable']) {
        disable = true;
        let { sourceAnswerInternalIdentifier, targetAnswerInternalIdentifier } = ruleMap['Disable'];
        let targetAnswer = targetAnswerInternalIdentifier?.findIndex((a) => a === ansItem?.answerInternalIdentifier) !== -1;
        if (!targetAnswer) {
            disable = false;
            return disable;
        }

        // To make the targetInternalIdentifier disable whenever ansValues are empty array
        let found;
        if (ansValues?.length) {
            found = sourceAnswerInternalIdentifier.some((sval) => {
                return ansValues.find((val) => val === sval);
            });
        } else {
            found = targetAnswerInternalIdentifier?.includes(ansItem?.answerInternalIdentifier);
            return found;
        }
        /*
         * let found =
         *     ansValues?.length > 0 &&
         *     sourceAnswerInternalIdentifier.every((sval) => {
         *         return ansValues.find((val) => val === sval);
         *     });
         */
        if (targetAnswer) {
            disable = found ? true : false;
        }
    }

    /*
     * find if target ansitem is called and have Deselect rules
     * if (ruleMap['Deselect']) {
     *     let { sourceAnswerInternalIdentifier, targetAnswerInternalIdentifier } = ruleMap['Deselect'];
     *     let targetAnswer = targetAnswerInternalIdentifier.findIndex((a) => a === ansItem?.answerInternalIdentifier) !== -1;
     *     if (!targetAnswer) {
     *         disable = false;
     *         return disable;
     *     }
     *     let found =
     *         ansValues?.length > 0 &&
     *         sourceAnswerInternalIdentifier.some((sval) => {
     *             return ansValues.find((val) => val === sval);
     *         });
     *     if (targetAnswer) {
     *         disable = found ? true : false;
     *     }
     * }
     */

    return disable;
};

export const checkForSelectDeselect = (item, ansItem, answerLevelRulesObj, updatedValObj, setState, assessment) => {
    if (!answerLevelRulesObj[item.questionInternalIdentifier]) return updatedValObj;
    if (
        item?.value &&
        item?.value?.checkboxAns?.length <= 1 &&
        item?.value?.textAns &&
        item?.value?.textAns?.length === 1 &&
        item?.value?.textAns[0]?.answer === ''
    )
        return updatedValObj;
    let rules = answerLevelRulesObj[item.questionInternalIdentifier].rule;
    // let ruleMap = {};
    let ruleMap = [];
    rules?.length > 0 &&
        rules.forEach((rule) => {
            ruleMap.push({ [rule.action]: { ...rule } });
        });
    let valueObj = cloneDeep(updatedValObj);
    for (let rule of ruleMap) {
        if (rule['Deselect']) {
            let { sourceAnswerInternalIdentifier, targetAnswerInternalIdentifier } = rule['Deselect'];
            let ansValues = getAllAnswersDupl({ value: valueObj });

            let found =
                ansValues?.length > 0 &&
                ansValues.find((val) => val === ansItem?.answerInternalIdentifier) &&
                sourceAnswerInternalIdentifier.find((sval) => sval === ansItem?.answerInternalIdentifier);

            if (found && valueObj.checkboxAns?.length > 0) {
                valueObj['checkboxAns'] = valueObj.checkboxAns.filter(
                    (ans) => !targetAnswerInternalIdentifier.find((ain) => ain === parseInt(ans))
                );
            }
            if (found && valueObj.radioAns && targetAnswerInternalIdentifier.find((ain) => ain === parseInt(valueObj.radioAns))) {
                valueObj['radioAns'] = '';
            }
            if (found && valueObj.textAns?.length > 0) {
                valueObj['textAns'] = valueObj.textAns.filter(
                    (ans) => !targetAnswerInternalIdentifier.find((ain) => ain === parseInt(ans?.answerInternalId))
                );
            }
        }

        // This help for Missori Cohort to disable the continue button
        if (rule['Enable'] && assessment?.formtype === PRAPARE_INFO) {
            let { sourceAnswerInternalIdentifier, button } = rule['Enable'];
            let ansValues = getAllAnswersDupl({ value: valueObj });
            let checkValues = item?.value?.dropdownAns?.length ? item?.value?.dropdownAns?.map((e) => e.value) : [];
            let found =
                ansValues?.length > 0 &&
                ansValues.find((val) => checkValues?.includes(val)) &&
                sourceAnswerInternalIdentifier.every((sval) => checkValues?.includes(sval));

            if (found && button) {
                setState(false);
            } else {
                setState(true);
            }
        }
    }
    return valueObj;
};

export const checkAnswerVisibleRule = (id, ansRule, ansId) => {
    const rules = ansRule[1]?.rule || [];

    const hideRole = rules.filter((item) => {
        return item.action === 'Hide' && item.role[0] === id;
    });

    let find = false;
    if (hideRole.length > 0) {
        find = hideRole.some((item) => {
            return item.answerInternalIdentifier.includes(ansId);
        });
    }

    return !find;
};

export const checkIsMandate = (ansId, id, ansRule) => {
    if (ansRule && ansRule[1]?.rule) {
        return ansRule[1]?.rule.some(
            (rule) => rule.role.includes(id) && rule.answerInternalIdentifier.includes(ansId) && rule.action === 'Mandatory'
        );
    }
};

// Throttle the handleSave function
export const throttledHandleSave = throttle((handleSave) => {
    handleSave();
}, 1000);

/*
 * export const formatPhoneNumber = (value) => {
 *     // if input value is falsy eg if the user deletes the input, then just return
 *     if (!value) return value;
 */

/*
 *     // clean the input for any non-digit values.
 *     const phoneNumber = value.replace(/[^\d]/g, '');
 */

/*
 *     // phoneNumberLength is used to know when to apply our formatting for the phone number
 *     const phoneNumberLength = phoneNumber.length;
 */

//     /*
//      * we need to return the value with no formatting if its less then four digits
//      * this is to avoid weird behavior that occurs if you  format the area code to early
//      */
//     if (phoneNumberLength < 4) return phoneNumber;

//     /*
//      * if phoneNumberLength is greater than 4 and less the 7 we start to return
//      * the formatted number
//      */
//     if (phoneNumberLength < 7) {
//         return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
//     }

//     /*
//      * finally, if the phoneNumberLength is greater then seven, we add the last
//      * bit of formatting and return it.
//      */
//     return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
// };

export const prepareObjectForCategory = (needGoal) => {
    const newArr = [];
    if (needGoal?.length) {
        needGoal?.forEach((item) => {
            let Obj = {
                needCategoryName: item?.needCategory?.name
            };
            if (item?.actionPlanTemplate?.length) {
                item?.actionPlanTemplate?.map((ele) => {
                    newArr.push({ ...Obj, ansInternalId: ele?.answerInternalIdentifiers, needSubCategoryName: ele?.needSubCategory.name });
                });
            } else {
                newArr.push({ ...Obj });
            }
        });
    }
    return newArr?.length ? [...newArr] : [];
};

// responseUtils.js

// Filter rules to find actions with 'Enable'
export const filterEnableActions = (data) => {
    const result = [];
    Object.values(data).forEach((item) => {
        const filteredRules = item.rule.filter((rule) => rule.action === 'Enable');
        result.push(...filteredRules);
    });
    return result;
};

// Check if any text question responses are not empty
export const isAnswerNotEmpty = (textQuesResponses) => {
    return textQuesResponses?.some((response) => response.answer !== '');
};

// Check if any text question responses are not empty
export const isAnswerNotAnswered = (textQuesResponses) => {
    return textQuesResponses?.some((response) => !response.answer);
};

// Process responses based on enable actions and other criteria
export const processResponses = (responses, enableActions) => {
    const results = [];

    responses?.forEach((response) => {
        const targetAnswerIds = response?.answerInternalId?.split(',').map((id) => id.trim());
        enableActions.forEach((action) => {
            const actionTargetIds = action?.targetAnswerInternalIdentifier;
            const sourceId = action?.sourceAnswerInternalIdentifier;
            const hasMatch = targetAnswerIds?.some((id) => actionTargetIds?.includes(parseInt(id, 10)));
            const hasFound = targetAnswerIds?.some((id) => sourceId?.includes(parseInt(id, 10)));

            /*
             * if (hasFound && hasMatch && !isAnswerNotEmpty(response.textQuesResponses)) {
             *     results.push({
             *         response
             *     });
             * }
             */

            if (hasFound && hasMatch && isAnswerNotAnswered(response.textQuesResponses)) {
                results.push({
                    response
                });
            }
        });
    });

    return results;
};

export const processHtmlContent = (html) => {
    const predefinedTags = new Set([
        'a',
        'abbr',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'base',
        'bdi',
        'bdo',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'cite',
        'code',
        'col',
        'colgroup',
        'data',
        'datalist',
        'dd',
        'del',
        'details',
        'dfn',
        'dialog',
        'div',
        'dl',
        'dt',
        'em',
        'embed',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hr',
        'html',
        'i',
        'iframe',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'link',
        'main',
        'map',
        'mark',
        'meta',
        'meter',
        'nav',
        'noscript',
        'object',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'script',
        'section',
        'select',
        'small',
        'source',
        'span',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'title',
        'tr',
        'track',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);

    return html?.replace(/<([^\/\s>]+)([^>]*)>/g, (match, tagName, attributes) => {
        if (predefinedTags.has(tagName.toLowerCase())) {
            return match; // Keep predefined tags as they are
        }
        // Encode custom tags
        return `&lt;${tagName}${attributes}&gt;`;
    });
};

// To disable the continue button based on the rules
export const checkAnswerIdToDisableButton = (entireAssessment, questions, index, setDisableBtn) => {
    if (entireAssessment?.assessment?.formtype === PRAPARE_INFO && index === 0) {
        let { answerLevelRules } = prepareRulesObj(entireAssessment);
        let questionInternalId = questions[index]?.questionInternalIdentifier;
        let answerIds = getAllAnswersDupl(questions[index]);
        if (questionInternalId && answerLevelRules[questions[index]?.questionInternalIdentifier]?.rule?.length) {
            let sourceAnswerIds = answerLevelRules[questions[index]?.questionInternalIdentifier].rule?.filter(
                (item) =>
                    item?.button === 'continue_assessment' &&
                    item?.action === 'Enable' &&
                    answerIds?.includes(Number(item?.targetAnswerValue))
            );
            const filterData =
                sourceAnswerIds?.length > 1
                    ? sourceAnswerIds?.find((item) => item?.sourceAnswerInternalIdentifier?.every((e) => answerIds?.includes(e)))
                          ?.sourceAnswerInternalIdentifier
                    : sourceAnswerIds[0]?.sourceAnswerInternalIdentifier;
            if (filterData?.length && filterData?.every((ansId) => answerIds?.includes(ansId))) {
                setDisableBtn(false);
            }
        }
    } else {
        setDisableBtn(false);
    }
};
export const handleAlertRules = (alertRules, field, answerInternalIds, langCode) => {
    let alertMsg = '';
    if (
        alertRules[field?.questionInternalIdentifier] &&
        alertRules[field?.questionInternalIdentifier]?.config?.length > 0 &&
        answerInternalIds?.length === 1
    ) {
        let configArr = alertRules[field?.questionInternalIdentifier]?.config?.find((ele) =>
            answerInternalIds?.some((e) => ele?.answerInternalIdentifier?.includes(e))
        )?.messageConfig;
        alertMsg = configArr?.length ? configArr?.find((ele) => convertToLowerCase(ele?.languageCode) === langCode)?.message : '';
    }
    return alertMsg;
};

export const languageMappingWithCode = {
    English: 'en',
    Español: 'es',
    Português: 'pt',
    Russian: 'ru',
    Korean: 'ko',
    '中文 (简体)': 'zh-cn',
    // Middle Eastern languages
    العربية: 'ar',
    Vietnamese: 'vi',
    '中文 (简体)': 'zh'
};
